<template>
  <div class="data-plaform-box container">
    <AnimeTitle
      :title="$t('dataPlatform.title')"
      svgRefValue="dataPlatformAnimeTitle"
      :computingTitle="$t('dataPlatform.computingTitle')"
    />
    <div
      class="secondary-title"
      data-animation="fade-scale-up"
      data-once="false"
    >
      {{ $t('dataPlatform.subTitle') }}
    </div>
    <div class="plaform-box-content">
      <div
        class="plaform-box-left"
        data-animation="fade-scale-up"
        data-once="false"
        @mouseleave="handleListMouseLeave"
      >
        <div
          v-for="(item, index) in list"
          :key="index"
          class="platform-box-list-item"
          :class="{ 'is-active': platformHoverIndex === index }"
          @mouseenter="handlePlatformEnter(index)"
        >
          <span>{{ item.title }}</span>
          <div class="plaform-box-list-desc">{{ item.descr }}</div>
          <div v-if="currentLocale === 'en'" class="plaform-box-list-child">
            <div
              class="plaform-box-list-desc-child"
              v-for="(child, childIndex) in item.child"
              :key="childIndex"
            >
              {{ child }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="plaform-box-right"
        data-animation="fade-scale-up"
        data-once="false"
      >
        <el-carousel
          direction="vertical"
          :autoplay="false"
          ref="elCarousel"
          :loop="false"
          indicator-position="none"
        >
          <el-carousel-item
            v-for="(item, index) in imgList"
            :key="index"
            class=""
          >
            <img :src="item" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    list() {
      return [
        {
          title: this.$t('dataPlatform.list.item0.title'),
          descr: this.$t('dataPlatform.list.item0.descr'),
        },
        {
          title: this.$t('dataPlatform.list.item1.title'),
          descr: this.$t('dataPlatform.list.item1.descr'),
          child: [
            this.$t('dataPlatform.list.item1.child.item1'),
            this.$t('dataPlatform.list.item1.child.item2'),
          ],
        },
        {
          title: this.$t('dataPlatform.list.item2.title'),
          descr: this.$t('dataPlatform.list.item2.descr'),
        },
        {
          title: this.$t('dataPlatform.list.item3.title'),
          descr: this.$t('dataPlatform.list.item3.descr'),
          child: [
            this.$t('dataPlatform.list.item1.child.item1'),
            this.$t('dataPlatform.list.item1.child.item2'),
          ],
        },
      ];
    },
  },

  data() {
    return {
      platformHoverIndex: 0,
      imgList: [
        require('@/assets/img/pc/plaform-box-right-1.png'),
        // require('@/assets/img/pc/plaform-box-right-2.png'),
        require('@/assets/img/pc/plaform-box-right-2.png'),
        require('@/assets/img/pc/plaform-box-right-3.png'),
        require('@/assets/img/pc/plaform-box-right-4.png'),
      ],
    };
  },
  methods: {
    handleListMouseLeave() {
      this.platformHoverIndex = 0;
      this.$refs.elCarousel.setActiveItem(0);
    },
    handlePlatformEnter(index) {
      this.platformHoverIndex = index;
      this.$refs.elCarousel.setActiveItem(index);
    },
  },
};
</script>
<style lang="scss" scoped>
.data-plaform-box :deep(.el-carousel__container) {
  height: 500px;
}
.data-plaform-box {
  padding: 120px 0;
  .plaform-box-content {
    display: flex;
    margin-top: 60px;
    .plaform-box-left {
      flex: 1;
      text-align: left;
      margin-right: 36px;
      .plaform-box-left-title {
        font-family: 'MiSans-Demibold';
        font-size: 24px;
        color: #005fe6;
        line-height: 32px;
        padding-bottom: 21px;
        border-bottom: transparent 3px solid;
        margin-bottom: 20px;
        .plaform-box-left-desc {
          font-weight: 400;
          font-size: 14px;
          font-family: '';
          color: #222226;
          line-height: 24px;
          margin-top: 6px;
        }
      }
      .platform-box-list-item {
        font-size: 24px;
        color: #5c5c66;
        margin-bottom: 20px;
        // font-family: 'MiSans-Regular';
        font-family: 'MiSans-Demibold';
        cursor: pointer;
        padding-bottom: 21px;
        border-bottom: transparent 3px solid;
        transition: all 0.5s ease;

        &:hover,
        &.is-active {
          border-bottom: #005fe6 3px solid;
          color: #005fe6;
          font-family: 'MiSans-Demibold';
          .plaform-box-list-desc {
            color: #222226;
            transition: all 0.5s ease;
          }
          .plaform-box-list-desc-child {
            color: #222226;
            transition: all 0.5s ease;
          }
        }
      }
      .plaform-box-list-desc {
        font-size: 14px;
        color: #757580;
        line-height: 24px;
        margin-top: 6px;
        font-family: auto;
        transition: all 0.5s ease;
      }
    }
    .plaform-box-right {
      width: 680px;

      border-radius: 20px;
      height: 500px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: left top;
      }
    }
  }
}
</style>
